<template>
  <div>
    <section id="footer-area" class="footer-area-section">
      <div class="container" style="padding:0px">
        <div class="copy-right-menu">
          <div class="row">
            <div class="col-md-12">
              <div class="copy-right-text" style="display: flex; justify-content: space-between; align-items: center;">
                <p>{{Copyright}}
                </p>
                <p>
                  <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">{{KeepCode}}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { ProjectSettings } from '@/views/base/base.js'
export default {
  data() {
    return {
      Copyright: ProjectSettings.Copyright,
      KeepCode: ProjectSettings.KeepCode
    }
  },
  mounted() {
  }
}
</script>
<style scoped>
.footer-area-section {
  padding: 80px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/footer.vue